import { wishOwner } from '../utils/wishOwner';

/**
 * SurpriseBadge — the "this is a surprise, keep it quiet" marker on a wish card.
 *
 * A surprise gift is a wish a group member added ON BEHALF of its owner, hidden
 * from that owner but visible/giftable to the rest of the group (FEEDBACK_PLAN.md
 * §5). We render this only when `suggested_by_user_id` is set — which, in this
 * app, means exactly a surprise gift (accepted suggestions mint a plain wish with
 * no suggester). The API's global visibility scope guarantees the recipient never
 * receives these wishes at all, so this badge is only ever seen by NON-recipients
 * and needs no client-side hiding logic.
 */
export default function SurpriseBadge({ wish, className = '' }) {
    if (!wish?.suggested_by_user_id) return null;
    const ownerName = wishOwner(wish).name;
    const by = wish.suggested_by?.name;
    return (
        <span
            className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded bg-amber-100 text-amber-800 ${className}`}
            title={by ? `Added by ${by} — hidden from ${ownerName}` : `Hidden from ${ownerName}`}
        >
            🎁 Surprise for {ownerName} — keep it secret
        </span>
    );
}
